export const SET_CONTAINER = 'TRANSFORM_AREA::SET_CONTAINER';
export function setContainer(container, containerType) {
    return {
        type: SET_CONTAINER,
        container,
        containerType,
    };
}

export const SET_IMAGE = 'TRANSFORM_AREA::SET_IMAGE';
export function setImage(image) {
    return {
        type: SET_IMAGE,
        image,
    };
}

export const SET_TEXT = 'TRANSFORM_AREA::SET_TEXT';

export function setText(text) {
    return {
        type: SET_TEXT,
        text,
    };
}

export const OPEN_TRANSFORM_AREA = 'TRANSFORM_AREA::OPEN';
export function openTransformArea() {
    return {
        type: OPEN_TRANSFORM_AREA,
    };
}

export const CLOSE_TRANSFORM_AREA = 'TRANSFORM_AREA::CLOSE';
export function closeTransformArea() {
    return {
        type: CLOSE_TRANSFORM_AREA,
    };
}

export const RESET_TRANSFORM_AREA = 'TRANSFORM_AREA::RESET';
export function resetTransformArea() {
    return {
        type: RESET_TRANSFORM_AREA,
    };
}
